<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M38.37 28.57a1.5 1.5 0 00-.74 2.91s3.37.93 3.37 3C41 37.45 33.42 41 24 41S7 37.45 7 34.52c0-2.09 3.35-3 3.37-3a1.5 1.5 0 00-.74-2.91C7.54 29.11 4 31 4 34.52 4 40.38 14.38 44 24 44s20-3.62 20-9.48c0-3.52-3.54-5.41-5.63-5.95z"/><path d="M22.94 31.58a1.51 1.51 0 002.12 0L32 24.63a1.49 1.49 0 000-2.12 1.51 1.51 0 00-2.12 0l-4.38 4.38V5.5A1.5 1.5 0 0024 4a1.5 1.5 0 00-1.5 1.5v21.39l-4.38-4.38a1.51 1.51 0 00-2.12 0 1.49 1.49 0 000 2.12z"/></svg>